import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-insurance",
  "use": "app-insurance-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-insurance\"><defs><style>#app-insurance .cls-1{fill:#ffb93d;}#app-insurance .cls-2{fill:#fff;}</style></defs><title>资源 37</title><g id=\"app-insurance_图层_2\" data-name=\"图层 2\"><g id=\"app-insurance_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M39,13.64l-1.3,0a18.54,18.54,0,0,1-6-1.3,27.79,27.79,0,0,1-5.1-2.75L25.81,9,25,9.58a25.62,25.62,0,0,1-5.1,2.75,18.62,18.62,0,0,1-6,1.3l-1.32,0V27.1c0,6.76,8.56,13.9,13.16,13.9S39,33.86,39,27.1ZM29.5,28.83H27.18V30a1.36,1.36,0,0,1-2.71,0V28.83H22.16a1.13,1.13,0,1,1,0-2.27h2.31V26H22.16a1.19,1.19,0,0,1-1-.55,1.12,1.12,0,0,1,0-1.16,1.23,1.23,0,0,1,1-.56h1.32l-2.18-3.06a1.31,1.31,0,0,1-.05-1.34,1.33,1.33,0,0,1,2.29-.06l2.29,3.31,2.3-3.32a1.34,1.34,0,0,1,1.8-.41,1.3,1.3,0,0,1,.45,1.78l-2.22,3.11H29.5a1.13,1.13,0,0,1,0,2.27H27.18v.55H29.5a1.13,1.13,0,1,1,0,2.27Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-insurance.svg
// module id = JDc9
// module chunks = 264